module.exports = __webpack_public_path__ + "static/media/26-8.2c2ea95b.mp3";